import { cediSign } from '../../utils/constants';
import { NumCount } from "../../components";
import { HugeiconsIcon } from '@hugeicons/react';
import { Money01Icon } from '@hugeicons/core-free-icons';

function Card({ title, disburseData, accent = "blue" }) {
    const accentMap = {
        blue:   { bg: "bg-blue-50",   border: "border-blue-100",   icon: "text-[#1e3a6e]" },
        green:  { bg: "bg-emerald-50", border: "border-emerald-100", icon: "text-emerald-600" },
        amber:  { bg: "bg-amber-50",  border: "border-amber-100",  icon: "text-amber-600" },
        purple: { bg: "bg-purple-50", border: "border-purple-100", icon: "text-purple-600" },
    };
    const { bg, border, icon } = accentMap[accent] || accentMap.blue;

    return (
        <div className="bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700 rounded-xl p-5 flex flex-col gap-3 shadow-sm">
            <div className="flex items-center justify-between">
                <p className="text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wide">{title}</p>
                <div className={`w-7 h-7 rounded-lg ${bg} border ${border} flex items-center justify-center`}>
                    <HugeiconsIcon icon={Money01Icon} size={14} className={icon} />
                </div>
            </div>
            <p className="text-2xl font-bold text-gray-900 dark:text-gray-50 tabular-nums">
                <NumCount symbol={cediSign} number={disburseData?.todayTotal} deci="." />
            </p>
        </div>
    );
}

export default Card;
